exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.on-left[data-v-57db69ce]{margin-top:-7px;margin-right:5px\n}\n#domains[data-v-57db69ce]{margin:15px 10%\n}\n@media(max-width: 945px){\n#domains[data-v-57db69ce]{margin-left:5px;margin-right:5px\n}\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-57db69ce","scoped":true,"sourceMap":true}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/spa/domain/DomainList.vue
// module id = 162
// module chunks = 0